// src/shared/components/common/empty-state.tsx

import { Inbox } from 'lucide-react'
import type { ReactNode } from 'react'

import { Card } from '@/shared/components/ui/card'
import { cn } from '@/shared/utils/cn'

interface EmptyStateProps {
  title: string
  description?: string
  action?: ReactNode
  icon?: ReactNode
  className?: string
  align?: 'center' | 'start'
}

export function EmptyState({
  title,
  description,
  action,
  icon,
  className,
  align = 'center',
}: EmptyStateProps) {
  return (
    <Card padding="lg" className={cn(className)}>
      <div
        className={cn(
          'flex flex-col gap-3 py-6',
          align === 'center' ? 'items-center text-center' : 'items-start text-left',
        )}
      >
        <span className="flex h-10 w-10 items-center justify-center rounded-full bg-[var(--panel-subtle)] text-[var(--color-text-muted)]">
          {icon ?? <Inbox className="h-5 w-5" />}
        </span>
        <h3 className="font-display text-base font-semibold text-[var(--color-text)]">{title}</h3>
        {description ? (
          <p className="max-w-md text-sm text-[var(--color-text-soft)]">{description}</p>
        ) : null}
        {action ? <div className="mt-1">{action}</div> : null}
      </div>
    </Card>
  )
}
